import { useEffect, useState } from 'react';
import { Printer, X } from 'lucide-react';

export const BarcodeStartPositionModal = ({ open, onClose, onConfirm }) => {
  const [position, setPosition] = useState(1);

  useEffect(() => {
    if (open) setPosition(1);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" role="dialog" aria-modal="true" aria-labelledby="barcode-position-title">
      <div className="bg-white rounded-sm w-full max-w-md shadow-xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h2 id="barcode-position-title" className="text-lg font-bold text-slate-900 uppercase tracking-tight">
            Select Start Position
          </h2>
          <button type="button" onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600" aria-label="Close">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-slate-600 mb-4">
            Choose the first sticker position to use. Earlier positions in the first row will be left empty.
          </p>
          <div className="grid grid-cols-5 gap-2" data-testid="barcode-start-positions">
            {[1, 2, 3, 4, 5].map(option => (
              <button
                key={option}
                type="button"
                onClick={() => setPosition(option)}
                data-testid={`barcode-start-position-${option}`}
                className={`h-12 border text-sm font-bold transition-colors ${
                  position === option
                    ? 'border-orange-500 bg-orange-50 text-orange-600'
                    : 'border-slate-200 text-slate-600 hover:border-orange-300'
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        <div className="flex justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-slate-200 text-slate-700 rounded-sm hover:bg-white">
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(position)}
            data-testid="confirm-barcode-print"
            className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm hover:bg-orange-600"
          >
            <Printer className="h-4 w-4" /> Print
          </button>
        </div>
      </div>
    </div>
  );
};
